import { Component, OnInit,ViewChild,HostListener } from '@angular/core';
import {CaseService} from '../services/case.service';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {Angular2Csv} from 'angular2-csv/Angular2-csv';
import {CaseAdvanceSearch} from '../../housekeeping/models/data-model';
import {GlobalDataService} from '../../housekeeping/services/global-data.service';
import {CalendarModule} from 'primeng/primeng';
import * as moment from 'moment';
import {ExportAvailability} from '../../../config';
import {Router} from '@angular/router';

@Component({
  selector: 'app-cases-export',
  templateUrl: '../views/cases-export.component.html',
  styleUrls: ['../css/cases-export.component.css']
})
export class CasesExportComponent implements OnInit {
  public userId: string;
  public statusList: any;
  public searchKey: any;
  public priorityList: any;
  public caseTypeList:any;
  public caseSourceList:any;
  public AssignedToList:any;
  public showBack: boolean = false;
  public showNext: boolean = true;
  public noData: boolean = false;
  public data: any = [];
  public enablePagination: boolean = true;
  public offset: number = 0;
  public limit=10;
  public showsubmission: boolean = true;
  public showsubmissionrange: boolean = false;
  public exportData:any;
  public prepareCurrentToSave: any = [];
  public finalExportData: any = [];
  public temp: any;
  public headerData: any = [];
  public rowdata: any = [];
  public refine: any = [];
  public columns: any = [];
  public current: any = [];
  public remaining: any = [];
  public addToRemaining: any = [];
  public addTocurrent: any = [];
  public savePreference: any;
  public index: number;
  public dealerList:any;
  public showRequiredMsg: boolean = false;
  public moveToTab2: boolean = false;
  public EXPORT = ExportAvailability.export;
  @ViewChild('openDateCal') datePicker1;
  @ViewChild('searchForm') searchFormObj:any;
  public advancesearchfields = new CaseAdvanceSearch(this.userId, this.searchKey, '', '', '', '', '', '', '', null, null, '', null, this.offset, this.limit, true,"ASC","","",[],false);
  
     //dropdown values
    public statusSelected: any = [];
    public prioritySelected: any = [];
    public caseTypeSelected: any = [];
    public dealerSelected: any = [];
    public assignToSelected: any = [];
    public caseSourceSelected: any = [];
  
        public statusSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'code',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public prioritySettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'code',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public caseTypeSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'code',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public dealerSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public assignToSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'fullName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    public caseSourceSettings = {
        singleSelection: false,
        idField: 'id',
        textField: 'code',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 1,
        allowSearchFilter: false
    };
    //Boolean
    public isStatusAll: boolean=false;
    public isPriorityAll: boolean=false;
    public isCaseTypeAll: boolean=false;
    public isDealerAll: boolean=false;
    public isAssignToAll: boolean=false;
    public isCaseSourceAll: boolean=false;
  
  constructor(public _caseService: CaseService,public _dataService: GlobalDataService,private _router:Router) { }

  ngOnInit() {
    if(!this.EXPORT){
        this._router.navigate(['/cases']);
    }
    //this.userId = localStorage.getItem('userId');
    this.userId = sessionStorage.getItem('userId');
    this.getStatusList();
    this.getPriorityList();
    this.getCaseTypeList();
    this.getCaseSourceList();
    this.getDealerList();
    this.getPreference();
    this.getAssignToList();
    //untill search criteria is entered tab2,3 will be hidden.
    const tab2 = document.getElementById('tab12');
    const tab3 = document.getElementById('tab13');
    tab2.classList.add("disabled");
    tab3.classList.add("disabled");
  }
   /* @Author :Sowmya */
   
    getStatusList() {
      this._caseService.getStatusList(this.userId, (result) => {
      this.statusList = result;
          
      });

    }

    getPriorityList() {
        this._caseService.getPriorityList(this.userId, (result) => {
        this.priorityList = result;
         
    });

    }

    getCaseTypeList() {
        this._caseService.getCaseTypeList(this.userId, (result) => {
        this.caseTypeList = result;
        
    });
    }

    getCaseSourceList() {
        this._caseService.getCaseSourceList(this.userId, (result) => {
        this.caseSourceList = result;
    });
    }
    getDealerList() {
        this._caseService.getDealerList(this.userId, (result) => {
            this.dealerList = result;
        });
    }
    getAssignToList() {
        this._caseService.getAssignToWithFullName(this.userId, (result) => {
            this.AssignedToList = result;
        });
    }
    fromCurrent(value, index) {
      const assign = document.getElementById("current_" + index);
      assign.classList.toggle("active");
        if (this.addToRemaining.indexOf(value) !== -1) {
            this.index = this.addToRemaining.indexOf(value);
            this.addToRemaining.splice(this.index, 1)
        }
        else {this.addToRemaining.push(value);}
    }
    fromRemaining(value, index) {
      const assign = document.getElementById("remaining_" + index);
      assign.classList.toggle("active");
        if (this.addTocurrent.indexOf(value) !== -1) {
            this.index = this.addTocurrent.indexOf(value);
            this.addTocurrent.splice(this.index, 1)
        }
        else {this.addTocurrent.push(value);}
    }
    filterCurrent() {
        this.addToRemaining.forEach(Obj => {
            this.remaining.push(Obj)
        });
        this.addToRemaining.forEach(each => {
            this.index = this.current.indexOf(each);
            this.current.splice(this.index, 1)
        });
        this.addToRemaining = [];
    }

    filterRemaining() {
        this.addTocurrent.forEach(Obj => {
            this.current.push(Obj)
        });
        this.addTocurrent.forEach(each => {
            this.index = this.remaining.indexOf(each);
            this.remaining.splice(this.index, 1)
        });
        this.addTocurrent = [];
    }
    
    advanceSearch() {
        //To assign active class
        if(Object.keys(this.statusSelected).length > 0 || 
        Object.keys(this.prioritySelected).length > 0 ||
        Object.keys(this.caseTypeSelected).length > 0 ||
        this.advancesearchfields.caseNumber != '' ||
        this.advancesearchfields.vin != '' ||
        Object.keys(this.caseSourceSelected).length > 0 ||
        Object.keys(this.assignToSelected).length > 0 ||
        Object.keys(this.dealerSelected).length > 0 ||
        this.advancesearchfields.caseOpenDate != null ||
        this.advancesearchfields.fromDate != null ||
        this.advancesearchfields.toDate != null){
        
        
        this.advancesearchfields.statusIds = [];
        this.advancesearchfields.priorityIds = [];
        this.advancesearchfields.dealerIds = [];
        this.advancesearchfields.caseSourceIds = [];
        this.advancesearchfields.assignTos= [];
        this.advancesearchfields.caseTypeIds = [];
        /**
         * @author Nagendra
         * @description dropdowns value are checked,if select all/unselect all used then boolean value for that will be true and it sends empty array
         */
        if (Object.keys(this.statusSelected).length > 0 && this.statusSelected != undefined && this.isStatusAll != true) {
            Object.keys(this.statusSelected).map(key => this.advancesearchfields.statusIds.push(this.statusSelected[key]['id']));
        }
        if (Object.keys(this.prioritySelected).length > 0 && this.prioritySelected != undefined && this.isPriorityAll != true) {
            Object.keys(this.prioritySelected).map(key => this.advancesearchfields.priorityIds.push(this.prioritySelected[key]['id']));
        }
        if (Object.keys(this.caseTypeSelected).length > 0 && this.caseTypeSelected != undefined && this.isCaseTypeAll != true ) {
            Object.keys(this.caseTypeSelected).map(key => this.advancesearchfields.caseTypeIds.push(this.caseTypeSelected[key]['id']));
        }
        if (Object.keys(this.dealerSelected).length > 0 && this.dealerSelected != undefined && this.isDealerAll != true) {
            Object.keys(this.dealerSelected).map(key => this.advancesearchfields.dealerIds.push(this.dealerSelected[key]['id']));
        }
        if (Object.keys(this.assignToSelected).length > 0 && this.assignToSelected != undefined && this.isAssignToAll != true) {
            Object.keys(this.assignToSelected).map(key => this.advancesearchfields.assignTos.push(this.assignToSelected[key]['id']));
        }
        if (Object.keys(this.caseSourceSelected).length > 0 && this.caseSourceSelected != undefined && this.isCaseSourceAll != true) {
            Object.keys(this.caseSourceSelected).map(key => this.advancesearchfields.caseSourceIds.push(this.caseSourceSelected[key]['id']));
        }


          const tab11 = document.getElementById("tab11");
          tab11.classList.remove("active");
            tab11.classList.add("disabled");
          const tab12 = document.getElementById("tab12");
          tab12.classList.add("active");
            tab12.classList.remove("disabled");
          const tab13 = document.getElementById("tab13");
          tab13.classList.remove("active");
            tab13.classList.add("disabled");
            this.data = [];
            this.advancesearchfields.userId = this.userId;
            this.advancesearchfields.isPagination = this.enablePagination;
            this.advancesearchfields.offset = this.offset;
            this.showRequiredMsg = false;
            this.moveToTab2 = true;
            this._caseService.caseAdvanceSearch(this.advancesearchfields, (result) => {
                 this.data = result.beans;
                 if (this.data == '') {
                     this.showNext = false;
                     this.noData = true;
                 }
                 if (this.data.length < '10' && result != '') {
                     this.showNext = false;
                     this.noData = false;
                 }
                 if (this.data.length == '10') {
                     this.showNext = true;
                     this.noData = false;
                 }
             }); 
          }else{
            this.moveToTab2 = false;
            this.showRequiredMsg = true;
          }
    } 
    GoBack() {
        this.offset -= 10;
        if (this.offset == 0) {
            this.showBack = false;
            this.noData = false;
        }
        if (this.offset != 0) {
            this.showNext = true;
        }
        this.advanceSearch();

      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");
    }
    
    nextPage() {
        this.offset += 10;
        if (this.offset != 0) {
            this.showBack = true;
        }
        this.advanceSearch();

      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");
    }
    returnToSearch() {
      const tab11 = document.getElementById("tab11");
      tab11.classList.add("active");
        tab11.classList.remove("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.remove("active");
        tab13.classList.add("disabled");
        
    }
     getPreference() {
        this.current = [];
        this.remaining = [];
        this._caseService.getcasePreference(this.userId, (result) => {
            if (result.length != 0) {
                result.forEach(each => {
                    this.current.push(each.setting.label);
                });
                this._caseService.getviewSettings(allPreference => {
                    allPreference.forEach(res => {
                        this.refine.push(res.label);
                    });
                  const thisObj = this;
                  this.refine.filter(function (item) {
                        if (thisObj.current.indexOf(item) === -1) {thisObj.remaining.push(item)}
                    });
                });
            } else {[this.current, this.remaining] = this._caseService.setDefaultPreferenceForCase(this.current, this.remaining);}
        });

    }
    setUserPreference() {
        //To assign active class
      const tab11 = document.getElementById("tab11");
      tab11.classList.remove("active");
        tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.remove("active");
        tab12.classList.add("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.add("active");
        tab13.classList.remove("disabled");
        this.savePreference = {};
        this.prepareCurrentToSave = [];
        this.finalExportData = [];
        this.rowdata = [];
        this.headerData = [];
        this._caseService.getviewSettings(allPreference => {
            allPreference.forEach(field => {
                this.current.forEach((obj, index) => {
                    if (field.label == obj) {
                        this.headerData.splice(index, 0, obj);
                      const object = field.property;
                      const refined = object.substring(object.indexOf(".") + 1);
                      field.property = refined.trim();
                        this.prepareCurrentToSave.splice(index, 0, {
                            "label": obj,
                            "property": field.property,
                        })
                    }
                })
            });

        });
        this.rowdata = this.prepareCurrentToSave;
    }
    reset() {
        this.current = [];
        this.remaining = [];
        this.addToRemaining = [];
        this.addTocurrent = [];
        this.refine = [];
        this.getPreference();
    }
    showdaterange(val) {
        if (this.showsubmission) {
            this.showsubmission = false;
            this.showsubmissionrange = val;
        } else {
            this.showsubmission = val;
            this.showsubmissionrange = false;
        }

    }
    
    returnToFieldSettings() {
      const tab11 = document.getElementById("tab11");
      tab11.classList.remove("active");
        tab11.classList.add("disabled");
      const tab12 = document.getElementById("tab12");
      tab12.classList.add("active");
        tab12.classList.remove("disabled");
      const tab13 = document.getElementById("tab13");
      tab13.classList.remove("active");
        tab13.classList.add("disabled");
    }
    exportList() {
       
        this.enablePagination = false;
        this.advancesearchfields.isPagination = this.enablePagination;
      const today: string = moment().format('D MMM YYYY HH:mm:ss');
      const options = {
        showLabels: true,
        headers: this.headerData
      };
      this._caseService.caseAdvanceSearch(this.advancesearchfields, (result) => {
            this.exportData = result;
            this.exportData.forEach(eachObj => {
                this.temp = {};
                this.prepareCurrentToSave.forEach(prefprop => {
                    if(eachObj[prefprop.property]!=""||eachObj[prefprop.property]!=null){
                            if (prefprop.property == "dateCreated") {
                            eachObj[prefprop.property] = moment(eachObj[prefprop.property]).format("MM/DD/YYYY ");
                        }
                        this.temp[prefprop.label] = eachObj[prefprop.property];
                    }else{
                        this.temp[prefprop.label] = null;
                    }
                });
                this.finalExportData.push(this.temp);
            });
            new Angular2Csv(this.finalExportData, 'My_Report' + today, options);
        });
        this.enablePagination = true;
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/cases/components/cases-export.component.ts